/**
 * @generated SignedSource<<01232dee66988142ad1378499d9b08c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraGoalStatus = "ARCHIVED" | "AT_RISK" | "CANCELLED" | "COMPLETED" | "DONE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type goalGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly goal: {
    readonly score: number | null | undefined;
    readonly status: JiraGoalStatus | null | undefined;
  };
  readonly " $fragmentType": "goalGroupHeader_issueTableGrouping";
};
export type goalGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: goalGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"goalGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goalGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraGoal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "status"
        },
        {
          "kind": "ScalarField",
          "name": "score"
        }
      ]
    }
  ],
  "type": "JiraJqlGoalsFieldValue"
};

(node as any).hash = "ff278af7d79d0614b5dc07558d4a411c";

export default node;
